import React from 'react'
import { TextHeading, get } from '@ally/metronome-ui'
import styled from 'styled-components'
import { Private } from '@ally/private'
import { standardIraPlanAccountLabel } from '../../utils/formatter'
import { IraPlan } from '../../types'
import { BeneficiariesTable } from '../common/BeneficiariesTable'

const StyledAccountLabel = styled(TextHeading)`
  padding-bottom: ${get.space('md')};
`

export const IraAccountView: React.FC<{ account: IraPlan }> = ({ account }) => {
  return (
    <>
      <StyledAccountLabel
        tag="h3"
        size="xs"
        weight="normal"
        tabIndex={-1}
        id={`${account.planId}-heading`}
        data-testid={`${account.planId}-ira-heading`}
      >
        <Private>{standardIraPlanAccountLabel(account)}</Private>
      </StyledAccountLabel>
      <BeneficiariesTable
        account={account}
        isIraPage
        accountLabel={standardIraPlanAccountLabel(account)}
      />
    </>
  )
}
